export class WebsiteTag {
  public id: any;
  public title: string;
  public clientId: number;
  public domains: any;
  public allDomainsHas: any = false;
  public someDomainsHas: any = false;
  public clickedValue: any = "some";
}
